import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose"; // @flow

import React from 'react';
import IconBoxTheme from './theme';
/*::
import type { Node } from 'react';
import type { IconBoxThemeType } from './theme';

export type Props = {|
  iconSrc: string,
  iconAlt?: string,
  label?: string,
  text?: string,
  theme?: IconBoxThemeType,
  rest?: any,
|}
*/

var IconBox = function IconBox(_ref
/*: Props */
) {
  var iconSrc = _ref.iconSrc,
      _ref$iconAlt = _ref.iconAlt,
      iconAlt = _ref$iconAlt === void 0 ? '' : _ref$iconAlt,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? '' : _ref$label,
      _ref$text = _ref.text,
      text = _ref$text === void 0 ? '' : _ref$text,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? IconBoxTheme : _ref$theme,
      rest = _objectWithoutPropertiesLoose(_ref, ["iconSrc", "iconAlt", "label", "text", "theme"]);

  return /*#__PURE__*/React.createElement(theme.Main, rest, /*#__PURE__*/React.createElement(theme.Icon, {
    src: iconSrc,
    alt: iconAlt,
    loading: "lazy"
  }), label ? /*#__PURE__*/React.createElement(theme.Label, null, label) : null, text ? /*#__PURE__*/React.createElement(theme.Text, null, text) : null);
};

export default IconBox;